module.exports = __webpack_public_path__ + "static/img/2-2.9908fc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/2-2.jpg
// module id = rD3x
// module chunks = 25